module.exports = __webpack_public_path__ + "img/tree-06-j-leaves.5f3e81d6.png";